export interface SystemRestoreResponse {
  message: string
}
